import { render, staticRenderFns } from "./PublicationStorageFilesHistoryList.vue?vue&type=template&id=cb84a5ee&"
import script from "./PublicationStorageFilesHistoryList.vue?vue&type=script&lang=js&"
export * from "./PublicationStorageFilesHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports